import type { Components } from '@mui/material/styles';

export default function MuiImageList(): Components['MuiImageList'] {
  return {};
}
